<template>
    <aside class="menu bg-gray-200 text-gray-900 min-h-full w-80 p-4">
        <!-- Header del perfil -->
        <div class="mb-6 p-4 bg-gray-300 rounded-lg">
            <h3 class="font-bold text-lg text-gray-800">{{ capitalizeSellerName }}</h3>
            <p class="text-sm text-gray-600">Panel de usuario</p>
        </div>



        <li class="mb-2">
            <RouterLink to="/" @click="handleRouterLinkClick"
                class="w-full text-start font-semibold text-gray-900 hover:bg-gray-300">
                <!-- Icono de inicio -->
                <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7,21h10c2.2,0,4-1.8,4-4v-6.5c0-1.3-0.6-2.4-1.6-3.2l-5-3.8C13,2.5,11,2.5,9.6,3.6l-5,3.7C3.6,8.1,3,9.2,3,10.5V17 C3,19.2,4.8,21,7,21z M5,10.5c0-0.6,0.3-1.2,0.8-1.6l5-3.8c0.4-0.3,0.8-0.4,1.2-0.4s0.8,0.1,1.2,0.4l5,3.8c0.5,0.4,0.8,1,0.8,1.6 V17c0,1.1-0.9,2-2,2H7c-1.1,0-2-0.9-2-2V10.5z" />
                </svg>
                Inicio
            </RouterLink>
        </li>


        <li class="mb-2">
            <RouterLink to="/profile" @click="handleRouterLinkClick"
                class="w-full text-start font-semibold text-gray-900 hover:bg-gray-300">
                <!-- Icono de perfil -->
                <svg class="w-5 h-5" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z" />
                    <path d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z" />
                </svg>
                Perfil
            </RouterLink>
        </li>


        <li class="mb-2">
            <RouterLink to="/stock" @click="handleRouterLinkClick"
                class="w-full text-start font-semibold text-gray-900 hover:bg-gray-300">
                <!-- Icono de stock -->
                <svg class="w-5 h-5" viewBox="0 0 297 297" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M291.219,78.753L153.176,9.732c-2.943-1.473-6.409-1.473-9.353,0L5.781,78.753C2.238,80.525,0,84.145,0,88.107v189.808 c0,5.775,4.682,10.458,10.458,10.458h34.511c5.775,0,10.458-4.682,10.458-10.458V115.82h186.148v162.095 c0,5.775,4.682,10.458,10.458,10.458h34.511c5.775,0,10.458-4.682,10.458-10.458V88.107C297,84.145,294.762,80.525,291.219,78.753z" />
                    <path
                        d="M217.521,132.552H148.5c-4.043,0-7.32,3.277-7.32,7.32v61.701H79.479c-4.043,0-7.32,3.277-7.32,7.32v69.021 c0,4.043,3.277,7.32,7.32,7.32h138.042c4.043,0,7.32-3.277,7.32-7.32V139.873C224.842,135.829,221.564,132.552,217.521,132.552z" />
                </svg>
                Ver stock
            </RouterLink>
        </li>


        <li class="mb-2">
            <RouterLink to="/tracking" @click="handleRouterLinkClick"
                class="w-full text-start font-semibold text-gray-900 hover:bg-gray-300">
                <!-- Icono de envío -->
                <svg class="w-5 h-5" viewBox="0 0 48 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <rect x="4" y="26" width="6" height="4"></rect>
                    <rect x="4" y="18" width="6" height="4"></rect>
                    <rect x="4" y="10" width="6" height="4"></rect>
                    <path
                        d="M44,24l-4-8h-4v-4c0-2.2-1.8-4-4-4H16c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h2c0,2.209,1.791,4,4,4s4-1.791,4-4h7 c0,2.209,1.791,4,4,4s4-1.791,4-4h3V24z M38,36c0,0.551-0.449,1-1,1s-1-0.449-1-1s0.449-1,1-1S38,35.449,38,36z M22,37 c-0.551,0-1-0.449-1-1s0.449-1,1-1s1,0.449,1,1S22.551,37,22,37z M41,26h-1c-2.2,0-4-1.8-4-4v-3h2.146L41,24.708V26z">
                    </path>
                </svg>
                Consultar Envío
            </RouterLink>
        </li>


        <li class="mb-2">
            <button @click="toggleModal" class="w-full text-start font-semibold text-gray-900 hover:bg-gray-300">
                <!-- Icono de orden -->
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                Orden
            </button>
        </li>

        <div class="divider"></div>

        <li>
            <button @click="logOut" class="font-semibold text-red-700 hover:bg-red-50">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                </svg>
                Cerrar sesión
            </button>
        </li>
    </aside>

    <!-- Modal -->
    <OrderArticlesDetail v-model:open="isOrderModalOpen" v-model:dropdown="isDropdownOpen" />
</template>





<script setup lang="ts">

import { computed, ref } from 'vue';
// import { useRouter } from 'vue-router';
import { useUserAuthenticatedStore } from '../AuthComponent/stores/UserAuthenticated.store';
import OrderArticlesDetail from './Sub-Components/OrderArticlesDetail.vue';
import { onClickOutside } from '@vueuse/core';
import { useCancelOrder } from '../ConfirmOrderDetail/Composables/cancel-order';
import { config } from '../../config/utils';



interface Props {
    seller_name: string
}

const emit = defineEmits<{
    closeDrawer: []
}>()


const handleRouterLinkClick = () => {
    emit('closeDrawer')
}

const props = defineProps<Props>()

const userStore = useUserAuthenticatedStore()
const { cancelOrder } = useCancelOrder()

const isDropdownOpen = ref(false)
const dropdownRef = ref<HTMLElement | null>(null)


const isOrderModalOpen = ref(false)



onClickOutside(dropdownRef, () => {
    isDropdownOpen.value = false
})


const toggleModal = () => {
    isOrderModalOpen.value = !isOrderModalOpen.value
}


const capitalizeSellerName = computed(() => props.seller_name.charAt(0).toUpperCase() + props.seller_name.slice(1));

console.log(capitalizeSellerName.value)



// Funcion para cerrar sesion. Posible composable
// Funcion para cerrar sesion. Posible composable
// Funcion para cerrar sesion. Posible composable
const logOut = async () => {

    try {
        const logout = await fetch(`${config.URL_PICKLOG}/sessions/logout`, {
            // const logout = await fetch('http://localhost:8080/api/sessions/logout', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

        if (logout.ok) {
            localStorage.removeItem('fromPath')
            localStorage.removeItem('lastPath')
            cancelOrder()
            await userStore.initializeUserStore()
            window.location.reload()
        }
    } catch (error) {
        console.error('Error en logout:', error)
    }
}


</script>





<style scoped>
.dropdown-enter-active,
.dropdown-leave-active {
    transition: all 0.4s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}


/* Colores y efectos para los botones de navegacion */
.custom-nav-button {
    background-color: #f1b15a;
    color: white;
}

.custom-nav-button:hover {
    background-color: #f3bc74;
}

.custom-nav-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(241, 177, 90, 0.5);
}
</style>
